/*
  Collection of custom validation rules for order form
*/

import { optionsMember } from './order-form-validation-rules';
import { required, numeric, requiredIfFieldIs, requiredIfFieldContains, defaultStrMaxLength, alphaCharacters, alphaNumeric, minMaxLengthString, requiredIfNotEmpty, contactNumberFormat, validEmailFormat, notEndsWithB } from '../../helpr/generic-validation-rules';

/*
  Field Defaults
*/
export const investorInfoOrderObj = (obj) => {
  const investorCategory = obj.investorCategory.split('-')[0]
  return {
    fields: {
      investorCategory: {
        value: investorCategory,
        style: {}
      },
      applicantAssoc: {
        value: obj.applicantList.assoc,
        style: {}
      },
      primaryApplicant: {
        value: obj.primaryApplicant,
        style: {}
      },
      primaryContactLastname: {
        value: obj.primaryContactPerson.lastName,
        style: {}
      },
      primaryContactFirstname: {
        value: obj.primaryContactPerson.firstName,
        style: {}
      },
      primaryContactMiddlename: {
        value: obj.primaryContactPerson.middleName,
        style: {}
      },
      primaryContactRelation: {
        value: obj.primaryContactPerson.relation,
        style: {}
      },
      purchaseAmount: {
        value: obj.purchaseAmount.toString(),
        style: {}
      },
      nationality: {
        value: obj.nationality,
        style: {}
      },
      dateOfBirthOrIncorporation: {
        value: obj.dateOfBirthOrIncorporation,
        style: {}
      },
      placeOfBirthOrIncorporation: {
        value: obj.placeOfBirthOrIncorporation,
        style: {}
      },
      idType: {
        value: obj.idType,
        style: {}
      },
      idNumber: {
        value: obj.idNumber,
        style: {}
      },
      taxStatus: {
        value: obj.taxStatus,
        style: {}
      },
      parentCompany: {
        value: obj.businessDetails.parentCompany,
        style: {}
      },
      natureOfWorkOrPrincipalBusiness: {
        value: obj.businessDetails.nature,
        style: {}
      },
      nameOfEmployerOrBusiness: {
        value: obj.businessDetails.name,
        style: {}
      },
      sourcesOfIncome: {
        value: obj.businessDetails.sourcesOfIncome,
        style: {}
      }
    },
    dynamicFields: {
      applicantNames: obj.applicantList.applicants
    }
  }
}

export const investorInfoOrderObj2 = (obj) => {
  return {
    fields: {
      modeOfPaymentOption: {
        value: obj.modeOfPayment.option,
        style: {}
      },
      modeOfPaymentBank: {
        value: obj.modeOfPayment.bank,
        stye: {}
      },
      modeOfPaymentCheckNumber: {
        value: obj.modeOfPayment.checkNumber,
        stye: {}
      },
      modeOfPaymentDebitAccountNumber: {
        value: obj.modeOfPayment.debitAccountNumber,
        stye: {}
      },
      modeOfCollectionOfInterest: {
        value: obj.modeOfCollectionOfInterest,
        style: {}
      },
      bankPesoAccountNumber: {
        value: obj.bankPesoAccountNumber,
        style: {}
      },
      settBankCode: {
        value: obj.settBankCode,
        style: {}
      },
      statementDeliveryMode: {
        value: obj.statementDeliveryMode,
        style: {}
      },
      place: {
        value: obj.place,
        style: {}
      },
      addressStreetAddress: {
        value: obj.address.streetAddress,
        style: {}
      },
      addressDistrictOrTown: {
        value: obj.address.districtOrTown,
        style: {}
      },
      addressCity: {
        value: obj.address.city,
        style: {}
      },
      addressStateProvinceRegion: {
        value: obj.address.stateProvinceRegion,
        style: {}
      },
      addressCountry: {
        value: obj.address.country,
        style: {}
      },
      addressZipcode: {
        value: obj.address.zipCode,
        style: {}
      },
      presentAddressStreet: {
        value: obj.presentAddress.streetAddress,
        style: {}
      },
      presentAddressDistrictTown: {
        value: obj.presentAddress.districtOrTown,
        style: {}
      },
      presentAddressStateProvinceRegion: {
        value: obj.presentAddress.stateProvinceRegion,
        style: {}
      },
      presentAddressCountry: {
        value: obj.presentAddress.country,
        style: {}
      },
      presentAddressCity: {
        value: obj.presentAddress.city,
        style: {}
      },
      presentAddressZipCode: {
        value: obj.presentAddress.zipCode,
        style: {}
      },
      securityRegistration: {
        value: obj.securityRegistration,
        style: {}
      },
      pdtcDepositoryParticipantName: {
        value: obj.pdtcDepositoryParticipantName,
        style: {}
      },
      applicantNoCDBPID: {
        value: obj.applicantNoCDBPID,
        style: {}
      },
      pdtcDepositoryParticipantBPID: {
        value: obj.pdtcDepositoryParticipantBPID,
        style: {}
      },
      pdtcDepositoryParticipantOmnibusAccNo: {
        value: obj.pdtcDepositoryParticipantOmnibusAccNo,
        style: {}
      }
    },
    dynamicFields: {
      contactTelephoneNumbers: obj.contactNumbers.telephoneNumbers,
      contactFaxNumbers: obj.contactNumbers.faxNumbers
    }
  }
}

/*
  Investor Information Form Fields Configuration
  Validation rules setup for use-validation hook
*/
export const investorInfoValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    investorCategory: [ 
      required,
      v => optionsMember(v, 'investorCategory')
    ],
    applicantAssoc: [],
    primaryApplicant: [
      v => requiredIfFieldContains(v, 'investorCategory', ['CORP', 'INDV - QIB', 'INDV - TRUST', 'CORP - QIB', 'CORP - TRUST']),
      v => minMaxLengthString(v, 0, 150)
    ],
    primaryContactLastname: [
      v => requiredIfNotEmpty(v, 'primaryContactFirstname'),
      v => minMaxLengthString(v, 0, 150)
    ],
    primaryContactFirstname: [
      v => requiredIfNotEmpty(v, 'primaryContactLastname'),
      v => requiredIfNotEmpty(v, 'primaryContactFirstname'),
      v => minMaxLengthString(v, 0, 150)
    ],
    primaryContactMiddlename: [],
    primaryContactRelation: [
      v => requiredIfNotEmpty(v, 'primaryContactLastname'),
      v => requiredIfNotEmpty(v, 'primaryContactFirstname'),
      v => minMaxLengthString(v, 0, 150)
    ],
    purchaseAmount: [
      required,
      numeric
    ],
    nationality: [
      required,
      v => optionsMember(v, 'countries')
    ],
    dateOfBirthOrIncorporation: [ 
      v => requiredIfFieldContains(v, 'investorCategory', ['CORP', 'INDV - QIB', 'INDV - TRUST', 'CORP - QIB', 'CORP - TRUST']),
    ],
    placeOfBirthOrIncorporation: [ required ],
    idType: [
      required
    ],
    idNumber: [
      required,
      v => minMaxLengthString(v, 0, 30)
    ],
    taxStatus: [
      required
    ],
    parentCompany: [
      v => minMaxLengthString(v, 0, 150)
    ],
    natureOfWorkOrPrincipalBusiness: [
      required
    ],
    nameOfEmployerOrBusiness: [
      required
    ],
    sourcesOfIncome: [
      required
    ]
  },
  dynamicFields: {
    applicantNames: {
      first_name: [ 
        v => requiredIfFieldIs(v, 'investorCategory', 'INDV'),
        v => minMaxLengthString(v, 0, 50),
        alphaCharacters
      ],
      last_name: [ 
        v => requiredIfFieldIs(v, 'investorCategory', 'INDV'),
        v => minMaxLengthString(v, 0, 45),
        defaultStrMaxLength,
        alphaCharacters
      ],
      middle_name: [ 
        v => minMaxLengthString(v, 0, 45),
        alphaCharacters 
      ],
      email: [
        v => requiredIfFieldIs(v, 'investorCategory', 'INDV'),
        validEmailFormat
      ],
      date_of_birth: [
        v => requiredIfFieldIs(v, 'investorCategory', 'INDV')
      ]
    }
  }
}

export const investorInfoValidator2 = {
  fields: {
    modeOfPaymentOption: [
      required
    ],
    modeOfPaymentBank: [
      v => requiredIfFieldContains(v, 'modeOfPaymentOption', ['BANK_CHECK', 'DIRECT_DEBIT'])
    ],
    modeOfPaymentCheckNumber: [
      v => requiredIfFieldIs(v, 'modeOfPaymentOption', 'BANK_CHECK')
    ],
    modeOfPaymentDebitAccountNumber: [
      v => requiredIfFieldIs(v, 'modeOfPaymentOption', 'DIRECT_DEBIT')
    ],
    modeOfCollectionOfInterest: [
      required
    ],
    bankPesoAccountNumber: [
      required,
      alphaNumeric,
      v => minMaxLengthString(v, 0, 18)
    ],
    settBankCode: [
      required,
      v => minMaxLengthString(v, 0, 11)
    ],
    statementDeliveryMode: [
      required,
      v => optionsMember(v, 'deliveryMode')
    ],
    place: [
      required,
      v => optionsMember(v, 'placeOfResidence')
    ],
    addressStreetAddress: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    addressDistrictOrTown: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    addressCity: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    addressStateProvinceRegion: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    addressCountry: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    addressZipcode: [
      required,
      numeric,
      v => minMaxLengthString(v, 0, 5)
    ],
    presentAddressStreet: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    presentAddressDistrictTown: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    presentAddressCity: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    presentAddressStateProvinceRegion: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    presentAddressCountry: [
      required,
      v => minMaxLengthString(v, 0 ,70)
    ],
    presentAddressZipCode: [
      required,
      numeric,
      v => minMaxLengthString(v, 0, 5)
    ],
    securityRegistration: [ required ],
    pdtcDepositoryParticipantName: [
      v => requiredIfFieldIs(v, 'securityRegistration', 'PDTC_CORP')
    ],
    applicantNoCDBPID: [
      v => requiredIfFieldIs(v, 'securityRegistration', 'PDTC_CORP'),
      notEndsWithB
    ],
    pdtcDepositoryParticipantBPID: [
      v => requiredIfFieldIs(v, 'securityRegistration', 'PDTC_CORP')
    ],
    pdtcDepositoryParticipantOmnibusAccNo: [
      v => requiredIfFieldIs(v, 'securityRegistration', 'PDTC_CORP')
    ]
  },
  dynamicFields: {
    contactTelephoneNumbers: [
      required,
      contactNumberFormat
    ],
    contactFaxNumbers: [
      required,
      contactNumberFormat
    ]
  }
}


